var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditEmployee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6465"
    },
    d: "M368.265,72.217H46.92c-21.533,0-38.989,17.455-38.989,38.988v289.59 c0,21.533,17.455,38.988,38.989,38.988h321.345c21.533,0,38.989-17.455,38.989-38.988v-289.59 C407.253,89.672,389.797,72.217,368.265,72.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#515262"
    },
    d: "M59.682,188.11c-4.007,0-7.266-3.259-7.266-7.265V113.32c0-4.006,3.259-7.264,7.266-7.264h302.292 c4.006,0,7.265,3.258,7.265,7.264v67.526c0,4.006-3.259,7.265-7.265,7.265H59.682z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52.417,
    y: 224.645,
    style: {
      fill: "#FFFFFF"
    },
    width: 133.313,
    height: 62.717
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.417,
    y: 331.024,
    style: {
      fill: "#FFFFFF"
    },
    width: 133.313,
    height: 62.717
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.663,
    y: 224.645,
    style: {
      fill: "#FFFFFF"
    },
    width: 133.313,
    height: 62.717
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.663,
    y: 331.024,
    style: {
      fill: "#FFFFFF"
    },
    width: 133.313,
    height: 62.717
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF999A"
    },
    d: "M497.882,231.709l-42.467-42.467c-8.248-8.248-21.622-8.248-29.871,0l-23.595,23.595l20.094,52.243 l52.243,20.094l23.595-23.595C506.13,253.332,506.13,239.958,497.882,231.709z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFEBBF"
    },
    points: "272.547,414.578 274.908,339.88 297.363,317.425 369.7,389.762 347.245,412.216 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD782"
    },
    points: "347.245,412.216 274.908,339.88 371.453,243.334 422.044,265.081 443.79,315.671 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.718,
    y: 242.673,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 535.033 750.0938)",
    style: {
      fill: "#515262"
    },
    width: 102.297,
    height: 43.13
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M497.882,231.709L467.973,201.8c8.249,8.249,8.248,21.622,0,29.871 L317.336,382.307l-43.812,1.385l-0.976,30.886l74.698-2.361L497.883,261.58C506.13,253.332,506.131,239.958,497.882,231.709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M92.527,400.795v-289.59c0-21.533,17.455-38.988,38.989-38.988H46.92 c-21.533,0-38.989,17.455-38.989,38.988v289.59c0,21.532,17.455,38.988,38.989,38.988h84.596 C109.983,439.784,92.527,422.328,92.527,400.795z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310.243,180.179c-4.381,0-7.931,3.551-7.931,7.931c0,4.38,3.55,7.931,7.931,7.931h51.731 c8.379,0,15.196-6.816,15.196-15.196V113.32c0-8.378-6.816-15.194-15.196-15.194H59.681c-8.379,0-15.197,6.816-15.197,15.194v67.526 c0,8.379,6.817,15.196,15.197,15.196h218.863c4.381,0,7.931-3.551,7.931-7.931c0-4.38-3.55-7.931-7.931-7.931H60.347v-66.193 h300.961v66.193H310.243z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.663,224.642c0-4.38-3.55-7.931-7.931-7.931H52.416c-4.381,0-7.931,3.551-7.931,7.931v62.717 c0,4.38,3.55,7.931,7.931,7.931h133.316c4.381,0,7.931-3.551,7.931-7.931v-62.717H193.663z M177.802,279.427H60.347v-46.856h117.454 v46.856H177.802z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.392,385.808c-4.381,0-7.931,3.551-7.931,7.931c0,4.38,3.55,7.931,7.931,7.931h28.341c4.381,0,7.931-3.551,7.931-7.931 v-62.717c0-4.38-3.55-7.931-7.931-7.931H52.416c-4.381,0-7.931,3.551-7.931,7.931v62.717c0,4.38,3.55,7.931,7.931,7.931h73.252 c4.381,0,7.931-3.551,7.931-7.931c0-4.38-3.55-7.931-7.931-7.931H60.347v-46.856h117.454v46.856H157.392z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M503.491,226.101l-42.467-42.467c-5.486-5.487-12.782-8.508-20.543-8.508c-7.761,0-15.055,3.021-20.544,8.509l-4.752,4.752 v-77.181c0-25.872-21.047-46.919-46.919-46.919H116.679c-4.381,0-7.931,3.551-7.931,7.931c0,4.38,3.55,7.931,7.931,7.931h251.586 c17.124,0,31.057,13.932,31.057,31.057v93.043l-2.98,2.98l-26.437,26.437v-9.024c0-4.38-3.55-7.931-7.931-7.931H228.658 c-4.381,0-7.931,3.551-7.931,7.931v62.717c0,4.38,3.55,7.931,7.931,7.931h79.624l-27.801,27.801h-51.821 c-4.381,0-7.931,3.551-7.931,7.931v62.717c0,4.38,3.55,7.931,7.931,7.931h36.363l-0.4,12.658c-0.069,2.189,0.771,4.31,2.318,5.858 c1.49,1.49,3.508,2.323,5.609,2.323c0.082,0,0.167-0.001,0.251-0.004l74.698-2.361c0.045-0.001,0.089-0.012,0.133-0.014 c0.314-0.015,0.628-0.047,0.939-0.099c0.041-0.007,0.084-0.011,0.124-0.018c0.338-0.062,0.672-0.151,1.001-0.258 c0.066-0.021,0.13-0.045,0.196-0.068c0.297-0.105,0.59-0.226,0.876-0.368c0.03-0.015,0.059-0.026,0.088-0.041 c0.306-0.155,0.601-0.335,0.888-0.534c0.058-0.04,0.114-0.085,0.172-0.127c0.223-0.164,0.44-0.34,0.649-0.53 c0.061-0.055,0.124-0.109,0.184-0.166c0.035-0.034,0.073-0.062,0.108-0.097l46.469-46.469v29.44 c0,17.125-13.933,31.057-31.057,31.057H46.92c-17.125-0.001-31.058-13.933-31.058-31.058v-289.59 c0-17.125,13.933-31.057,31.058-31.057h38.035c4.381,0,7.931-3.551,7.931-7.931s-3.55-7.931-7.931-7.931H46.92 C21.049,64.286,0,85.335,0,111.205v289.59c0,25.872,21.049,46.919,46.92,46.919h321.345c25.872,0,46.919-21.047,46.919-46.919 v-45.301l34.214-34.214l30.498-30.498l23.594-23.594c5.487-5.487,8.51-12.783,8.51-20.543 C512,238.885,508.977,231.588,503.491,226.101z M443.79,304.456l-61.122-61.122l19.282-19.282l61.122,61.122L443.79,304.456z  M401.647,346.599c-0.001,0.001-0.001,0.001-0.002,0.002L347.245,401l-61.122-61.122l3.25-3.25c0.001-0.001,0.002-0.002,0.003-0.003 l43.648-43.648c0.004-0.004,0.008-0.007,0.013-0.011l34.545-34.545c0.001-0.001,0.002-0.003,0.003-0.004l3.866-3.867l61.122,61.122 L401.647,346.599z M236.588,279.427v-46.856h117.454v16.955l-29.9,29.899h-87.554V279.427z M236.588,385.808v-46.856h30.443 c-0.003,0.023-0.003,0.048-0.005,0.072c-0.011,0.093-0.014,0.186-0.021,0.279c-0.007,0.109-0.021,0.216-0.024,0.326l-1.459,46.179 H236.588z M280.741,406.384l1.515-47.939l46.424,46.424L280.741,406.384z M492.273,255.972l-17.986,17.986l-61.122-61.122 l17.986-17.986c2.491-2.491,5.804-3.863,9.328-3.863c3.523,0,6.836,1.372,9.327,3.863l42.467,42.467 c2.49,2.491,3.863,5.803,3.863,9.327C496.138,250.168,494.766,253.48,492.273,255.972z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditEmployee);
export default __webpack_public_path__ + "static/media/edit-employee.c5f3fb2864211852e974a3acefc6d7e6.svg";
export { ForwardRef as ReactComponent };